/**
 * SQL utility functions for handling schema compatibility issues
 */

function isSQLWhitespace(char: string | undefined): boolean {
  return char === ' ' || char === '\t' || char === '\n' || char === '\r';
}

function findTokenLeftBoundary(sql: string, index: number): number {
  let left = index - 1;
  while (left >= 0 && isSQLWhitespace(sql[left])) {
    left--;
  }
  return left;
}

function findTokenRightBoundary(sql: string, index: number): number {
  let right = index;
  while (right < sql.length && isSQLWhitespace(sql[right])) {
    right++;
  }
  return right;
}

function removeDelimitedProjection(sql: string, start: number, end: number): string {
  const left = findTokenLeftBoundary(sql, start);
  const right = findTokenRightBoundary(sql, end);

  if (left >= 0 && sql[left] === ',') {
    return `${sql.slice(0, left)}${sql.slice(end)}`;
  }

  if (right < sql.length && sql[right] === ',') {
    const afterComma = findTokenRightBoundary(sql, right + 1);
    return `${sql.slice(0, start)}${sql.slice(afterComma)}`;
  }

  return `${sql.slice(0, start)}${sql.slice(end)}`;
}

/**
 * Removes _gps_device_capture projection from SQL when the column is not available in the schema.
 * Used for forms that haven't been migrated to schema v6 yet.
 * @param sql The SQL query string
 * @returns The SQL query with _gps_device_capture projection removed if present
 */
export default function removeGpsDeviceCaptureProjection(sql: string): string {
  // When querying forms that are not yet on schema v6, _gps_device_capture is not present.
  // Remove the projection so query execution can degrade gracefully.
  const projection = '"_gps_device_capture" AS "gps_device_capture"';
  let nextSQL = sql;

  for (
    let projectionIndex = nextSQL.indexOf(projection);
    projectionIndex !== -1;
    projectionIndex = nextSQL.indexOf(projection)
  ) {
    const projectionEnd = projectionIndex + projection.length;
    nextSQL = removeDelimitedProjection(nextSQL, projectionIndex, projectionEnd);
  }

  return nextSQL;
}
